// extracted by mini-css-extract-plugin
export default {"root":"SectionHeader_root__nkwF-","title":"SectionHeader_title__mpLvB","description":"SectionHeader_description__fDJvA"};